import '../App.css';

function Header() {
  return (
    <>
      <header>
          <h1>Readability Calculator</h1>
      </header>
      <h2><a href="#background">⬇️Learn How This Works⬇️</a></h2>
    </>
  );
}

export default Header;